export const resultsList = [
  {
    code: '100',
    description: 'Transaction was approved',
  },
  {
    code: '200',
    description: 'Transaction was declined by processor',
  },
  {
    code: '201',
    description: 'Do not honor',
  },
  {
    code: '202',
    description: 'Insufficient funds',
  },
  {
    code: '203',
    description: 'Over limit',
  },
  {
    code: '204',
    description: 'Transaction not allowed',
  },
  {
    code: '220',
    description: 'Incorrect payment information',
  },
  {
    code: '221',
    description: 'No such card issuer',
  },
  {
    code: '222',
    description: 'No card number on file with issuer',
  },
  {
    code: '223',
    description: 'Expired card',
  },
  {
    code: '224',
    description: 'Invalid expiration date',
  },
  {
    code: '225',
    description: 'Invalid card security code',
  },
  {
    code: '226',
    description: 'Invalid PIN',
  },
  {
    code: '240',
    description: 'Call issuer for further information',
  },
  {
    code: '250',
    description: 'Pick up card',
  },
  {
    code: '251',
    description: 'Lost card',
  },
  {
    code: '252',
    description: 'Stolen card',
  },
  {
    code: '253',
    description: 'Fraudulent card',
  },
  {
    code: '260',
    description: 'Declined with further instructions available',
  },
  {
    code: '261',
    description: 'Declined-Stop all recurring payments',
  },
  {
    code: '262',
    description: 'Declined-Stop this recurring program',
  },
  {
    code: '263',
    description: 'Declined-Update cardholder data available',
  },
  {
    code: '264',
    description: 'Declined-Retry in a few days',
  },
  {
    code: '300',
    description: 'Transaction was rejected by gateway',
  },
  {
    code: '400',
    description: 'Transaction error returned by processor',
  },
  {
    code: '410',
    description: 'Invalid merchant configuration',
  },
  {
    code: '411',
    description: 'Merchant account is inactive',
  },
  {
    code: '420',
    description: 'Communication error',
  },
  {
    code: '421',
    description: 'Communication error with issuer',
  },
  {
    code: '430',
    description: 'Duplicate transaction at processor',
  },
  {
    code: '440',
    description: 'Processor format error',
  },
  {
    code: '441',
    description: 'Invalid transaction information',
  },
  {
    code: '460',
    description: 'Processor feature not available',
  },
  {
    code: '461',
    description: 'Unsupported card type',
  },
];
